// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ux0IEZYmuUOpBu {
  display: flex;
  position: fixed;
  z-index: -900;
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: var(--ds-background-neutral, #091e420f);
}
.sLT44Tlw33jQB0,
.XaA8YXwOYzOANy {
  position: absolute;
  z-index: -999;
  bottom: var(--ds-space-0, 0);
  width: 400px;
  max-width: 30%;
}
@media only screen and (max-width: 750px) {
  .sLT44Tlw33jQB0,
  .XaA8YXwOYzOANy {
    display: none;
  }
}
.sLT44Tlw33jQB0 {
  left: var(--ds-space-0, 0);
}
.XaA8YXwOYzOANy {
  right: var(--ds-space-0, 0);
}
`, ""]);
// Exports
export var background = `Ux0IEZYmuUOpBu`;
export var left = `sLT44Tlw33jQB0`;
export var right = `XaA8YXwOYzOANy`;
export default ___CSS_LOADER_EXPORT___;
